import React from "react";
import { useLocation } from "react-router-dom";
import "./explodedDrawing.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import { Link } from "react-router-dom";

import ExplodedDrawingImage1 from "../../assets/images/sample/emap01.svg";
import ExplodedDrawingImage2 from "../../assets/images/sample/emap02.svg";

function ExplodedDrawing() {
    const location = useLocation()
    return (
        <Page>
            <Header />
            <section className="container">
                <div className="row hrow headbox-dark">
                    <h3 className="title">نقشه انفجاری دستگاه</h3>
                    <span className="subtitle">{location.state.title}</span>
                </div>
                <div className="row hrow">
                    <img src={ExplodedDrawingImage1} className="img-fluid mb-5" alt="..." />
                    <img src={ExplodedDrawingImage2}  className="img-fluid mb-5" alt="..." />
                </div>
                <div className="row hrow">
                    <Link to="#" state={{ title: location.state.title }} className="DevicesDoc">
                        دریافت فایل
                    </Link>
                </div>
            </section>
            <Footer />
        </Page>
    );
}
export default ExplodedDrawing;
